import { H2, Stack, XStack, YStack } from '@bounty/creators-design-system'
import { GetStoreResponseSuccess } from '@bounty/types'
import { ShopBountiesCard } from './ShopBountiesCard'
import { useMemo } from 'react'

export const ShopBounties = ({
  shop,
}: {
  shop: GetStoreResponseSuccess['data']
}) => {
  const activeBriefs = useMemo(
    () =>
      shop?.briefs?.filter(({ isActive, isPublic }) => isActive && isPublic) ||
      [],
    [shop?.briefs],
  )

  return activeBriefs?.length > 0 ? (
    <YStack width="100%" maxWidth={1300} alignSelf="center">
      <H2 mb="$4" px="$4" size="$xl" $gtMd={{ size: '$2xl' }}>
        Bounties
      </H2>
      <XStack px="$4" flexWrap="wrap" gap="$3">
        {activeBriefs?.map(
          (
            brief: GetStoreResponseSuccess['data']['briefs']['0'],
            index: number,
          ) => {
            return (
              <Stack width="100%" mb="$4" $gtMd={{ width: '47%' }}>
                <ShopBountiesCard
                  shopBrandedHashTag={shop?.brandedHashtag || ''}
                  shopName={shop?.name}
                  shopSlug={shop?.slug}
                  minimumPayout={shop?.minBountyPayment}
                  shopImageSrc={shop?.logo || ''}
                  brief={brief}
                  key={index}
                  tiktokUsername={shop?.tikTokUsername || ''}
                  instagramUsername={shop?.instagramUsername || ''}
                />
              </Stack>
            )
          },
        )}
      </XStack>
    </YStack>
  ) : null
}
